export const sampleGridData = [
  {
    id: 1,
    openDate: '2025-11-13T18:30:00.000Z',
    bankName: 'Emirates NBD',
    amount: '750',
    utilizedAmount: '1000',
    status: 'active',
    renewalDate: '2025-11-13T18:30:00.000Z',
    sublimits: [
      {
        ProductID: 3,
        ProductName: 'Aniseed Syrup',
        SupplierID: 1,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 550 ml bottles',
        UnitPrice: 10,
        UnitsInStock: 13,
        UnitsOnOrder: 70,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 4,
        ProductName: "Chef Anton's Cajun Seasoning",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '48 - 6 oz jars',
        UnitPrice: 22,
        UnitsInStock: 53,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 5,
        ProductName: "Chef Anton's Gumbo Mix",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '36 boxes',
        UnitPrice: 21.35,
        UnitsInStock: 0,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: true,
        type: 'Funded',
      },
      {
        ProductID: 6,
        ProductName: "Grandma's Boysenberry Spread",
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 8 oz jars',
        UnitPrice: 25,
        UnitsInStock: 120,
        UnitsOnOrder: 0,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 8,
        ProductName: 'Northwoods Cranberry Sauce',
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 12 oz jars',
        UnitPrice: 40,
        UnitsInStock: 6,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 15,
        ProductName: 'Genen Shouyu',
        SupplierID: 6,
        CategoryID: 'Funded',
        QuantityPerUnit: '24 - 250 ml bottles',
        UnitPrice: 15.5,
        UnitsInStock: 39,
        UnitsOnOrder: 0,
        ReorderLevel: 5,
        Discontinued: false,
        type: 'Funded',
      },
    ],
  },
  {
    id: 2,
    openDate: '2025-11-13T18:30:00.000Z',
    bankName: 'Commercial Bank of Dubai',
    amount: '750',
    utilizedAmount: '1000',
    status: 'active',
    renewalDate: '2025-11-13T18:30:00.000Z',
    sublimits: [
      {
        ProductID: 3,
        ProductName: 'Aniseed Syrup',
        SupplierID: 1,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 550 ml bottles',
        UnitPrice: 10,
        UnitsInStock: 13,
        UnitsOnOrder: 70,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 4,
        ProductName: "Chef Anton's Cajun Seasoning",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '48 - 6 oz jars',
        UnitPrice: 22,
        UnitsInStock: 53,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 5,
        ProductName: "Chef Anton's Gumbo Mix",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '36 boxes',
        UnitPrice: 21.35,
        UnitsInStock: 0,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: true,
        type: 'Funded',
      },
      {
        ProductID: 6,
        ProductName: "Grandma's Boysenberry Spread",
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 8 oz jars',
        UnitPrice: 25,
        UnitsInStock: 120,
        UnitsOnOrder: 0,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 8,
        ProductName: 'Northwoods Cranberry Sauce',
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 12 oz jars',
        UnitPrice: 40,
        UnitsInStock: 6,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 15,
        ProductName: 'Genen Shouyu',
        SupplierID: 6,
        CategoryID: 'Funded',
        QuantityPerUnit: '24 - 250 ml bottles',
        UnitPrice: 15.5,
        UnitsInStock: 39,
        UnitsOnOrder: 0,
        ReorderLevel: 5,
        Discontinued: false,
        type: 'Funded',
      },
    ],
  },
  {
    id: 3,
    openDate: '2025-11-13T18:30:00.000Z',
    bankName: 'First Abu Dhabi Bank',
    amount: '750',
    utilizedAmount: '1000',
    status: 'expired',
    renewalDate: '2025-11-13T18:30:00.000Z',
    sublimits: [
      {
        ProductID: 3,
        ProductName: 'Aniseed Syrup',
        SupplierID: 1,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 550 ml bottles',
        UnitPrice: 10,
        UnitsInStock: 13,
        UnitsOnOrder: 70,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 4,
        ProductName: "Chef Anton's Cajun Seasoning",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '48 - 6 oz jars',
        UnitPrice: 22,
        UnitsInStock: 53,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 5,
        ProductName: "Chef Anton's Gumbo Mix",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '36 boxes',
        UnitPrice: 21.35,
        UnitsInStock: 0,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: true,
        type: 'Funded',
      },
      {
        ProductID: 6,
        ProductName: "Grandma's Boysenberry Spread",
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 8 oz jars',
        UnitPrice: 25,
        UnitsInStock: 120,
        UnitsOnOrder: 0,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 8,
        ProductName: 'Northwoods Cranberry Sauce',
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 12 oz jars',
        UnitPrice: 40,
        UnitsInStock: 6,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 15,
        ProductName: 'Genen Shouyu',
        SupplierID: 6,
        CategoryID: 'Funded',
        QuantityPerUnit: '24 - 250 ml bottles',
        UnitPrice: 15.5,
        UnitsInStock: 39,
        UnitsOnOrder: 0,
        ReorderLevel: 5,
        Discontinued: false,
        type: 'Funded',
      },
    ],
  },
  {
    id: 4,
    openDate: '2025-11-13T18:30:00.000Z',
    bankName: 'Emirates NBD',
    amount: '750',
    utilizedAmount: '1000',
    status: 'closed',
    renewalDate: '2025-11-13T18:30:00.000Z',
    sublimits: [
      {
        ProductID: 3,
        ProductName: 'Aniseed Syrup',
        SupplierID: 1,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 550 ml bottles',
        UnitPrice: 10,
        UnitsInStock: 13,
        UnitsOnOrder: 70,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 4,
        ProductName: "Chef Anton's Cajun Seasoning",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '48 - 6 oz jars',
        UnitPrice: 22,
        UnitsInStock: 53,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 5,
        ProductName: "Chef Anton's Gumbo Mix",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '36 boxes',
        UnitPrice: 21.35,
        UnitsInStock: 0,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: true,
        type: 'Funded',
      },
      {
        ProductID: 6,
        ProductName: "Grandma's Boysenberry Spread",
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 8 oz jars',
        UnitPrice: 25,
        UnitsInStock: 120,
        UnitsOnOrder: 0,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 8,
        ProductName: 'Northwoods Cranberry Sauce',
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 12 oz jars',
        UnitPrice: 40,
        UnitsInStock: 6,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 15,
        ProductName: 'Genen Shouyu',
        SupplierID: 6,
        CategoryID: 'Funded',
        QuantityPerUnit: '24 - 250 ml bottles',
        UnitPrice: 15.5,
        UnitsInStock: 39,
        UnitsOnOrder: 0,
        ReorderLevel: 5,
        Discontinued: false,
        type: 'Funded',
      },
    ],
  },
  {
    id: 5,
    openDate: '2025-11-13T18:30:00.000Z',
    bankName: 'Emirates NBD',
    amount: '750',
    utilizedAmount: '1000',
    status: 'active',
    renewalDate: '2025-11-13T18:30:00.000Z',
    sublimits: [
      {
        ProductID: 3,
        ProductName: 'Aniseed Syrup',
        SupplierID: 1,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 550 ml bottles',
        UnitPrice: 10,
        UnitsInStock: 13,
        UnitsOnOrder: 70,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 4,
        ProductName: "Chef Anton's Cajun Seasoning",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '48 - 6 oz jars',
        UnitPrice: 22,
        UnitsInStock: 53,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 5,
        ProductName: "Chef Anton's Gumbo Mix",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '36 boxes',
        UnitPrice: 21.35,
        UnitsInStock: 0,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: true,
        type: 'Funded',
      },
      {
        ProductID: 6,
        ProductName: "Grandma's Boysenberry Spread",
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 8 oz jars',
        UnitPrice: 25,
        UnitsInStock: 120,
        UnitsOnOrder: 0,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 8,
        ProductName: 'Northwoods Cranberry Sauce',
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 12 oz jars',
        UnitPrice: 40,
        UnitsInStock: 6,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 15,
        ProductName: 'Genen Shouyu',
        SupplierID: 6,
        CategoryID: 'Funded',
        QuantityPerUnit: '24 - 250 ml bottles',
        UnitPrice: 15.5,
        UnitsInStock: 39,
        UnitsOnOrder: 0,
        ReorderLevel: 5,
        Discontinued: false,
        type: 'Funded',
      },
    ],
  },
  {
    id: 6,
    openDate: '2025-11-13T18:30:00.000Z',
    bankName: 'Commercial Bank of Dubai',
    amount: '750',
    utilizedAmount: '1000',
    status: 'active',
    renewalDate: '2025-11-13T18:30:00.000Z',
    sublimits: [
      {
        ProductID: 3,
        ProductName: 'Aniseed Syrup',
        SupplierID: 1,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 550 ml bottles',
        UnitPrice: 10,
        UnitsInStock: 13,
        UnitsOnOrder: 70,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 4,
        ProductName: "Chef Anton's Cajun Seasoning",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '48 - 6 oz jars',
        UnitPrice: 22,
        UnitsInStock: 53,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 5,
        ProductName: "Chef Anton's Gumbo Mix",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '36 boxes',
        UnitPrice: 21.35,
        UnitsInStock: 0,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: true,
        type: 'Funded',
      },
      {
        ProductID: 6,
        ProductName: "Grandma's Boysenberry Spread",
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 8 oz jars',
        UnitPrice: 25,
        UnitsInStock: 120,
        UnitsOnOrder: 0,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 8,
        ProductName: 'Northwoods Cranberry Sauce',
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 12 oz jars',
        UnitPrice: 40,
        UnitsInStock: 6,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 15,
        ProductName: 'Genen Shouyu',
        SupplierID: 6,
        CategoryID: 'Funded',
        QuantityPerUnit: '24 - 250 ml bottles',
        UnitPrice: 15.5,
        UnitsInStock: 39,
        UnitsOnOrder: 0,
        ReorderLevel: 5,
        Discontinued: false,
        type: 'Funded',
      },
    ],
  },
  {
    id: 7,
    openDate: '2025-11-13T18:30:00.000Z',
    bankName: 'First Abu Dhabi Bank',
    amount: '750',
    utilizedAmount: '1000',
    status: 'active',
    renewalDate: '2025-11-13T18:30:00.000Z',
    sublimits: [
      {
        ProductID: 3,
        ProductName: 'Aniseed Syrup',
        SupplierID: 1,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 550 ml bottles',
        UnitPrice: 10,
        UnitsInStock: 13,
        UnitsOnOrder: 70,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 4,
        ProductName: "Chef Anton's Cajun Seasoning",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '48 - 6 oz jars',
        UnitPrice: 22,
        UnitsInStock: 53,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 5,
        ProductName: "Chef Anton's Gumbo Mix",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '36 boxes',
        UnitPrice: 21.35,
        UnitsInStock: 0,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: true,
        type: 'Funded',
      },
      {
        ProductID: 6,
        ProductName: "Grandma's Boysenberry Spread",
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 8 oz jars',
        UnitPrice: 25,
        UnitsInStock: 120,
        UnitsOnOrder: 0,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 8,
        ProductName: 'Northwoods Cranberry Sauce',
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 12 oz jars',
        UnitPrice: 40,
        UnitsInStock: 6,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 15,
        ProductName: 'Genen Shouyu',
        SupplierID: 6,
        CategoryID: 'Funded',
        QuantityPerUnit: '24 - 250 ml bottles',
        UnitPrice: 15.5,
        UnitsInStock: 39,
        UnitsOnOrder: 0,
        ReorderLevel: 5,
        Discontinued: false,
        type: 'Funded',
      },
    ],
  },
  {
    id: 8,
    openDate: '2025-11-13T18:30:00.000Z',
    bankName: 'Emirates NBD',
    amount: '750',
    utilizedAmount: '1000',
    status: 'active',
    renewalDate: '2025-11-13T18:30:00.000Z',
    sublimits: [
      {
        ProductID: 3,
        ProductName: 'Aniseed Syrup',
        SupplierID: 1,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 550 ml bottles',
        UnitPrice: 10,
        UnitsInStock: 13,
        UnitsOnOrder: 70,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 4,
        ProductName: "Chef Anton's Cajun Seasoning",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '48 - 6 oz jars',
        UnitPrice: 22,
        UnitsInStock: 53,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 5,
        ProductName: "Chef Anton's Gumbo Mix",
        SupplierID: 2,
        CategoryID: 'Funded',
        QuantityPerUnit: '36 boxes',
        UnitPrice: 21.35,
        UnitsInStock: 0,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: true,
        type: 'Funded',
      },
      {
        ProductID: 6,
        ProductName: "Grandma's Boysenberry Spread",
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 8 oz jars',
        UnitPrice: 25,
        UnitsInStock: 120,
        UnitsOnOrder: 0,
        ReorderLevel: 25,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 8,
        ProductName: 'Northwoods Cranberry Sauce',
        SupplierID: 3,
        CategoryID: 'Funded',
        QuantityPerUnit: '12 - 12 oz jars',
        UnitPrice: 40,
        UnitsInStock: 6,
        UnitsOnOrder: 0,
        ReorderLevel: 0,
        Discontinued: false,
        type: 'Funded',
      },
      {
        ProductID: 15,
        ProductName: 'Genen Shouyu',
        SupplierID: 6,
        CategoryID: 'Funded',
        QuantityPerUnit: '24 - 250 ml bottles',
        UnitPrice: 15.5,
        UnitsInStock: 39,
        UnitsOnOrder: 0,
        ReorderLevel: 5,
        Discontinued: false,
        type: 'Funded',
      },
    ],
  },
];

export const historyItems = [
  {
    user: 'John Doe',
    action: 'facility added',
    type: 'facility',
    subLimitId: '',
    timestamp: '2024-12-01T12:00:00Z',
    validFrom: '2024-12-01T12:00:00Z',
    validTo: '2024-12-02T12:00:00Z',
  },
  {
    user: 'Jane Smith',
    action: 'facility status updated',
    type: 'sublimit',
    subLimitId: 'xxxx-xxxx-xxxxx',
    timestamp: '2024-12-02T14:30:00Z',
    validFrom: '2024-12-02T14:30:00Z',
    validTo: '2024-12-03T14:30:00Z',
  },
  {
    user: 'Alice Brown',
    action: 'sublimit removed',
    type: 'sublimit',
    subLimitId: 'yyyy-yyyy-yyyyy',
    timestamp: '2024-12-03T10:00:00Z',
    validFrom: '2024-12-03T10:00:00Z',
    validTo: '2024-12-04T10:00:00Z',
  },
  {
    user: 'Michael Green',
    action: 'facility updated',
    type: 'facility',
    subLimitId: '',
    timestamp: '2024-12-04T16:45:00Z',
    validFrom: '2024-12-04T16:45:00Z',
    validTo: '2024-12-05T16:45:00Z',
  },
  {
    user: 'Emily Clark',
    action: 'facility added',
    type: 'facility',
    subLimitId: '',
    timestamp: '2024-12-05T08:20:00Z',
    validFrom: '2024-12-05T08:20:00Z',
    validTo: '2024-12-06T08:20:00Z',
  },
  {
    user: 'Daniel Lee',
    action: 'sublimit updated',
    type: 'sublimit',
    subLimitId: 'zzzz-zzzz-zzzzz',
    timestamp: '2024-12-06T11:15:00Z',
    validFrom: '2024-12-06T11:15:00Z',
    validTo: '2024-12-07T11:15:00Z',
  },
  {
    user: 'Sophia Martinez',
    action: 'facility removed',
    type: 'facility',
    subLimitId: '',
    timestamp: '2024-12-07T13:30:00Z',
    validFrom: '2024-12-07T13:30:00Z',
    validTo: '2024-12-08T13:30:00Z',
  },
  {
    user: 'Chris Evans',
    action: 'sublimit added',
    type: 'sublimit',
    subLimitId: 'aaaa-bbbb-ccccc',
    timestamp: '2024-12-08T09:45:00Z',
    validFrom: '2024-12-08T09:45:00Z',
    validTo: '2024-12-09T09:45:00Z',
  },
  {
    user: 'Laura Taylor',
    action: 'facility updated',
    type: 'facility',
    subLimitId: '',
    timestamp: '2024-12-09T14:00:00Z',
    validFrom: '2024-12-09T14:00:00Z',
    validTo: '2024-12-10T14:00:00Z',
  },
];
